export const getEditItemsOrderDetails = ({ state }) => state.editItems.editItemsOrderDetails;
export const getOrderDetailsPriceInfo = ({ state }) => state.editItems.priceInfo;
export const getIsEditItemsQtyModalOpen = ({ state }) => state.editItems.isQtyModalOpen;
export const getEditItemId = ({ state }) => state.editItems.itemId;
export const getEditItemQty = ({ state }) => state.editItems.itemQty;
export const getIsCustomItemModalOpen = ({ state }) => state.editItems.isCustomItemModalOpen;
